module.exports = __webpack_public_path__ + "static/media/chair.00f517e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/chair.png
// module id = 486
// module chunks = 0